import { Button } from "@/components/ui/button";
import { Link } from "@/components/ui/link";
import Invite from "@/components/invite";

export default function Hero() {
  return (
    <section className="py-20 text-center bg-muted/50">
      <div className="container mx-auto">
        <h1 className="text-5xl font-bold mb-6 mt-12">
          PentAGI: Advanced AI-Powered Penetration Testing
        </h1>
        <p className="text-xl mt-8 mb-8 max-w-2xl mx-auto">
          Fully autonomous AI Agent that performs complicated penetration
          testing tasks using terminal, browser, editor, and external search
          system.
        </p>
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col items-center mb-2">
            <Button size="lg" asChild>
              <Link href="/get-started">Get Started</Link>
            </Button>
          </div>

          <Invite />
        </div>
      </div>
    </section>
  );
}
